




import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/Header.vue";

@Component({
  components: {
    Header,
  },
})
export default class Lab extends Vue {
  @Prop(String) readonly publicId!: string;
  mounted() {
    if (this.$route.name === "Lab") {
      this.$router.push({ path: `login`, append: true });
    }
  }
}
